module.exports = __webpack_public_path__ + "img/features-bg_8.0cf643d7.png";